module.exports = __webpack_public_path__ + "img/qddt_dark.7bac8f48.png";